export function inr(v) {
  const n = Number(v) || 0;
  const a = Math.abs(n);
  const s = n < 0 ? "-" : "";
  if (a >= 1e7) return `${s}₹${(a / 1e7).toFixed(2)}Cr`;
  if (a >= 1e5) return `${s}₹${(a / 1e5).toFixed(2)}L`;
  if (a >= 1e3) return `${s}₹${Math.round(a / 1e3)}K`;
  return `${s}₹${Math.round(a)}`;
}

export const inrFull = (v) => `₹${Math.round(Number(v) || 0).toLocaleString("en-IN")}`;
export const pct = (v, d = 1) => `${(Number(v) || 0).toFixed(d)}%`;
export const num = (v, d = 0) => (Number(v) || 0).toLocaleString("en-IN", { maximumFractionDigits: d, minimumFractionDigits: d });

export const STATUS = {
  ahead: { label: "Ahead", text: "text-green-700", bg: "bg-green-50", border: "border-green-200", dot: "bg-green-600" },
  on_track: { label: "On Track", text: "text-sky-700", bg: "bg-sky-50", border: "border-sky-200", dot: "bg-sky-600" },
  behind: { label: "Behind", text: "text-orange-700", bg: "bg-orange-50", border: "border-orange-200", dot: "bg-orange-500" },
  critical: { label: "Critical", text: "text-red-700", bg: "bg-red-50", border: "border-red-200", dot: "bg-red-600" },
};

export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const title = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const fmtDate = (iso) =>
  iso ? new Date(iso + (iso.length === 10 ? "T00:00:00" : "")).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "";

export const monthLabel = (m) =>
  m ? new Date(`${m}-01T00:00:00`).toLocaleDateString("en-IN", { month: "long", year: "numeric" }) : "";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const PRESETS = [["today", "Today"], ["yesterday", "Yesterday"], ["this_week", "This Week"], ["last_week", "Last Week"],
  ["this_month", "This Month"], ["last_month", "Last Month"], ["custom", "Custom"]];

export function presetRange(p, asOf) {
  const t = new Date(`${asOf}T00:00:00`);
  const add = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
  const mon = add(t, -((t.getDay() + 6) % 7));
  const r = {
    today: [t, t], yesterday: [add(t, -1), add(t, -1)], this_week: [mon, add(mon, 6)], last_week: [add(mon, -7), add(mon, -1)],
    this_month: [new Date(t.getFullYear(), t.getMonth(), 1), new Date(t.getFullYear(), t.getMonth() + 1, 0)],
    last_month: [new Date(t.getFullYear(), t.getMonth() - 1, 1), new Date(t.getFullYear(), t.getMonth(), 0)],
  }[p] || [t, t];
  return { start: iso(r[0]), end: iso(r[1]) };
}

export const periodLabel = (r) => (r ? (r.start === r.end ? fmtDate(r.start) : `${fmtDate(r.start)} – ${fmtDate(r.end)}`) : "");
